// eslint-disable-next-line prettier/prettier

const initializedPixelIds = new Set()

const ensurePixelInitialized = pixelId => {
  if (!pixelId || !window.fbq || initializedPixelIds.has(pixelId)) {
    return
  }

  window.fbq('init', pixelId)
  initializedPixelIds.add(pixelId)
}

export const sendFacebookPixelEvent = async eventData => {
  const priceInfo = separateCurrencyAndValue(eventData.price)

  if (!priceInfo) {
    console.warn('Invalid price format for Facebook Pixel tracking:', eventData.price)

    return false
  }

  if (!window.fbq) {
    console.warn('Facebook Pixel not loaded')

    return false
  }

  window.fbq(
    'track',
    'Purchase',
    {
      value: priceInfo.value,
      currency: priceInfo.currency,
      contents: [
        {
          event_time: Math.floor(Date.now() / 1000),
          em: [await hashEmail(eventData.email)],
          event_id: eventData.eventId,
          action_source: 'website',
        },
      ],
      content_type: 'product',
    },
    {
      eventID: `${eventData.orderUuid}-purchase`,
    },
  )

  return true
}

export const sendOrganizationFacebookPixelEvent = async ({ pixelId, eventName, price, orderUuid, eventId, email }) => {
  if (!pixelId || !window.fbq) {
    return false
  }

  const priceInfo = separateCurrencyAndValue(price || '')
  if (!priceInfo) {
    return false
  }

  ensurePixelInitialized(pixelId)

  const eventID =
    eventName === 'Purchase'
      ? `${orderUuid}-purchase`
      : eventName === 'InitiateCheckout'
        ? `${orderUuid}-initcheckout`
        : orderUuid

  const content = {
    event_time: Math.floor(Date.now() / 1000),
    event_id: eventId,
    action_source: 'website',
  }

  if (email) {
    content.em = [await hashEmail(email)]
  }

  window.fbq(
    'trackSingle',
    pixelId,
    eventName,
    {
      value: priceInfo.value,
      currency: priceInfo.currency,
      contents: [content],
      content_type: 'product',
    },
    {
      eventID,
    },
  )

  return true
}

export const sendOrganizationFacebookPageView = pixelId => {
  if (!pixelId || !window.fbq) {
    return false
  }

  ensurePixelInitialized(pixelId)
  window.fbq('trackSingle', pixelId, 'PageView')

  return true
}

const hashEmail = async email => {
  const encoder = new TextEncoder()
  const data = encoder.encode(email)
  const hashBuffer = await crypto.subtle.digest('SHA-256', data)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('')

  return hashHex
}

const separateCurrencyAndValue = price => {
  const regex = /^([a-zA-Z]+)\s(\d+(\.\d+)?)/
  const match = price.match(regex)

  if (!match) {
    return null
  }

  return {
    currency: match[1],
    value: parseFloat(match[2]),
  }
}
